import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useMarketplaceContext } from 'utils/context/MarketplaceContext'
import { useGetAllOfferedShipments, usePostWaterfallReoffer } from '../types/apiTypes'
import {
  findOfferByRouteId,
  isOfferADedicatedRateOfferedToMoreCarriers,
} from '../utils/offerHelpers'
import { useFMSAnalytics } from './useFMSAnalytics/useFMSAnalytics'

interface IUseRateConfirmationState {
  getAndPostReoffer: () => {}
  isShipmentLoaded: boolean
  shipmentId: string
}

/**
 * Hook consolidating rate confirmation API calls/redirect logic.
 *
 */
export const useRateConfirmation = (): IUseRateConfirmationState => {
  const { trackEvent } = useFMSAnalytics()
  const { id } = useParams<{ id: string }>()
  const { getMarketplaceLoad, shipmentDetails } = useMarketplaceContext()
  const { mutate: getAllOfferedShipments } = useGetAllOfferedShipments({})
  const { mutate: postWaterfallReoffer } = usePostWaterfallReoffer({ id: parseInt(id, 10) })

  const getAndPostReoffer = async () => {
    const { offeredShipments = [] } = await getAllOfferedShipments()
    const offer = findOfferByRouteId(id, offeredShipments)
    if (isOfferADedicatedRateOfferedToMoreCarriers(offer)) {
      trackEvent('Offers', 'VIEWED_RATE_CONFIRMATION_AND_RE_OFFERED')
      await postWaterfallReoffer()
    }
    await getMarketplaceLoad(id)
  }

  const isShipmentLoaded = useMemo(() => !!shipmentDetails?.id, [shipmentDetails?.id])

  return {
    getAndPostReoffer,
    isShipmentLoaded,
    shipmentId: id,
  }
}
